var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTurquoiseTeardrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    transform: "translate(321 162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    fill: "#01828F",
    stroke: "#FFFFFF",
    d: "M-309.3-161c-4.8,0.2-8.6,4.2-8.5,9.1c0,0.5,0.1,0.9,0.2,1.3 c0,0,0,0.1,0.1,0.3c0.1,0.6,0.3,1.2,0.6,1.7c0.9,2.1,2.9,5.6,7.5,9.4c0.3,0.2,0.7,0.2,1,0c4.6-3.8,6.6-7.3,7.5-9.4 c0.3-0.6,0.5-1.1,0.6-1.7c0-0.2,0.1-0.3,0.1-0.3c0.1-0.5,0.2-1.1,0.2-1.7c0-4.8-3.9-8.8-8.8-8.8C-309.1-161-309.2-161-309.3-161z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_715",
    fill: "#FFFFFF",
    cx: -309,
    cy: -152.1,
    r: 4.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTurquoiseTeardrop);
export default __webpack_public_path__ + "static/media/icon_turquoise_teardrop.3a4e8922b47b9bb38642e80cb42a53eb.svg";
export { ForwardRef as ReactComponent };